import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { VERIFY_CAREGIVER_NRIC } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { VerifyCaregiverPayload, VerifyCaregiverResult } from '../types/verifyCaregiverNRIC.types';

export const verifyCaregiverNRIC = (builder: BuilderType) =>
  builder.query<VerifyCaregiverResult, VerifyCaregiverPayload>({
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: VERIFY_CAREGIVER_NRIC,
    }),
    transformResponse: (response: GenericApiResponse<VerifyCaregiverResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
